import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { Button, Title } from 'components';
import { Card, Col, Row } from 'antd';
import {
  ArrowLeftOutlined,
  BankOutlined,
  DollarOutlined,
  HomeOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { extra, getRoute, currentEntity } from 'components/Shortcuts';
import { useNavigate } from 'react-router-dom';
import { ENV_NAME, ENV_NAMES_ENUM } from 'utils/env';
import NavigationCard from 'views/Payments/components/NavigationCard';
import { padronesEnum } from 'views/Tramites/GPM/enums';
import PadronesIcons from 'assets/PadronesIcons';
import { selectPadrones } from 'store/catalogos';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

const entities = [ENV_NAMES_ENUM.JUAREZ];

const RenderPadrones = ({ padrones }) => {
  const icons = useMemo(() => ({
    [padronesEnum.CIUDADANO]: <UserOutlined />,
    [padronesEnum.EMPRESA]: <BankOutlined />,
    [padronesEnum.PREDIO]: <HomeOutlined />,
  }), []);

  return (
    <Row gutter={[10, 10]} justify="center">
      {padrones.map((item) => (
        <NavigationCard
          to={getRoute(item)}
          icon={icons?.[item.id] || <PadronesIcons padron={item.id} /> || <DollarOutlined />}
          text={item?.descripcion || item?.nombre}
          type="button"
          key={item.id}
        />
      ))}
    </Row>
  );
};

RenderPadrones.propTypes = {
  padrones: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    descripcion: PropTypes.string,
    nombre: PropTypes.string,
  })),
};

RenderPadrones.defaultProps = {
  padrones: [],
};

export const padronesText = (padron) => {
  const textByPadron = {
    [padronesEnum.VEHICULO]: 'Refrendo Vehicular',
    [padronesEnum.MOTOCICLETA]: 'Refrendo de Motocicletas',
    [padronesEnum.ALCOHOL]: 'Refrendo de Alcoholes',
    [padronesEnum.CASA_DE_EMPENIO]: 'Casa de Empeño',
  };
  return textByPadron[padron];
};

const CardTitle = () => {
  const navigate = useNavigate();

  return (
    <Row justify="center">
      <Col>
        <Title level={2} $accent $centered>
          Consulta de adeudos
        </Title>
      </Col>
      <Col span={24}>
        <Button
          style={{
            float: 'right',
          }}
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate('/pagos/')}
          $accent
        >
          Regresar
        </Button>
      </Col>
    </Row>
  );
};

const PadronesList = () => {
  const _padrones = useSelector(selectPadrones);
  const [padrones, setPadrones] = useState([]);

  const invertArr = useCallback((arr) => {
    const invert = entities.includes(ENV_NAME);
    return invert ? [...arr].reverse() : arr;
  }, [ENV_NAME]);

  useEffect(() => {
    let mounted = true;
    const fetch = async () => {
      if (mounted) {
        setPadrones(invertArr(_padrones.filter((p) => p.available
        // excluidos de consulta de adeudos
        && p.id !== padronesEnum.PREDIO
        && p.id !== padronesEnum.CONTRIBUYENTE))
          .concat(currentEntity.concatExtra ? extra() : []));
      }
    };
    fetch();
    return () => { mounted = false; };
  }, []);

  return (
    <Card style={{ background: 'transparent', width: '100%' }} title={(<CardTitle />)}>
      <RenderPadrones padrones={padrones} />
    </Card>
  );
};

export default PadronesList;
